// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"CPfUP4wRQQT_ZN3m-WTQr","spaceLeft":"_2Kn0uPDnKKkhor8IG7HSt8","spaceBoth":"_2GfIEqcG204UlkJq5N6c4b","spaceRight":"_21Lzv45qN-BIpSbSMr-NxT","table":"_1-D4iWvwjEhGJdGAzJL5Xu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisWrapUnwrapHistory.scss
// module id = 1294
// module chunks = 0